import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import CheckMark from "../../icons/checkmark.svg";
import ClosedLock from "../../icons/lock-closed.svg";
import { DEPRECATED_Typography } from "../DEPRECATED_Typography";
import { Icon } from "../Icon";
import styles from "./TiersStatuses.module.scss";
export const TiersStatuses = ({ items }) => {
    if (!items?.length)
        return null;
    return (_jsx("div", { className: styles.tiersStatuses, children: items.map(({ tierName, pointsRange, isAchieved }) => {
            return (_jsxs("div", { className: classNames(styles.tierItem, {
                    [styles.active]: isAchieved,
                }), "data-testid": `tier-${tierName}`, children: [_jsx(DEPRECATED_Typography, { className: styles.tierName, color: "black", weight: "bold", children: tierName }), _jsx(DEPRECATED_Typography, { className: styles.pointsRange, color: "black", children: pointsRange }), _jsx(Icon, { className: styles.icon, component: isAchieved ? CheckMark : ClosedLock, height: "22px" })] }, tierName));
        }) }));
};
//# sourceMappingURL=TiersStatuses.js.map